import React, { useState } from 'react';
import './SignUp.css'
import image from './images/fs22.png'
import image2 from './images/bgex2.jpg'
import { Link, useNavigate } from 'react-router-dom';
import {auth} from "./firebase";
import { signInWithEmailAndPassword } from 'firebase/auth';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useUserAuth } from './UserAuthContext';
import { Alert } from 'react-bootstrap';

function SignUp() {
    const navigate = useNavigate();
    const[name,setName] = useState('')
    const[email,setEmail] = useState('');
    const[error, setError] = useState('');
    const[password,setPassword] = useState('');
    const {signup} = useUserAuth();

    const handleSubmit = async(e) => {
        e.preventDefault();
        setError("");
        try{
            await signup(name, email, password);
            navigate("/")
        }
        catch(error){
                setError(error.message)
        }

    }

  return (
    <div className='signup'>
      <img className='imgbg' src = {image2} alt = ""/>
      <div className='signup-content'>
        <Link to = "/">
      <img className = "signup__logo" src = {image} alt = ""></img>
      </Link>
      <div className='signup__container'>
        <h1>Sign-Up</h1>
        {error && <Alert class = "error" variant = "danger">{error}</Alert>}
        <form onSubmit = {handleSubmit}>
            <h5>Your Name</h5>
            <input type = "text" value = {name} onChange = {e => setName(e.target.value)}/>
            <h5>E-mail</h5>
            <input type = "text" value = {email} onChange = {e => setEmail(e.target.value)}/>
            <h5>Password</h5>
            <input type = "password" value = {password} onChange = {e => setPassword(e.target.value)}/><br/>
            <button type = "submit" className={`signupButton ${email ? '' : 'low-opacity'}`} /*onClick={signIn}*/>Sign Up</button>
            <p className='signup__orSeparator'>
      <span className='signup__orText'>Or</span>
    </p>
            <a className = "already" href = "javascript:void(0)"><p>Already have an account ?</p></a>
        </form>
        <Link to = "/"><button className='signup__loginButton' /*onClick={register}*/>Take me to Login Page</button></Link>
      </div>
      </div>
        

    </div>
  );
}

export default SignUp;
